import type { DataTableColumn } from './data-table'

/**
 * The columns a DataTable shows, in the order it shows them. Shared with the
 * export so a download carries exactly what is on screen.
 */
export function visibleOrderedColumns<T>(
  columns: DataTableColumn<T>[],
  columnVisibility?: Record<string, boolean>,
  columnOrder?: string[],
): DataTableColumn<T>[] {
  // Respect defaultVisible for columns missing from the visibility map.
  const filtered = columns.filter((col) => {
    if (!columnVisibility) return col.defaultVisible !== false
    if (col.id in columnVisibility) return columnVisibility[col.id] !== false
    return col.defaultVisible !== false
  })
  if (!columnOrder) return filtered
  // Ids missing from the saved order go to the far right.
  return [...filtered].sort((a, b) => {
    const ai = columnOrder.indexOf(a.id)
    const bi = columnOrder.indexOf(b.id)
    if (ai === -1 && bi === -1) return 0
    if (ai === -1) return 1
    if (bi === -1) return -1
    return ai - bi
  })
}
